module.exports = __webpack_public_path__ + "img/house7b.d891fa28.jpg";